import { render } from "./FavoritesListView.vue?vue&type=template&id=82b8491e&scoped=true"
import script from "./FavoritesListView.vue?vue&type=script&lang=js"
export * from "./FavoritesListView.vue?vue&type=script&lang=js"

import "./FavoritesListView.vue?vue&type=style&index=0&id=82b8491e&scoped=true&lang=css"

import exportComponent from "C:\\_TimetipCode\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82b8491e"]])

export default __exports__